/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Empty_TitleInputs */

const en_jobs_empty_title = /** @type {(inputs: Jobs_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No jobs tracked yet`)
};

const de_jobs_empty_title = /** @type {(inputs: Jobs_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Stellen verfolgt`)
};

const fr_jobs_empty_title = /** @type {(inputs: Jobs_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun emploi suivi pour le moment`)
};

const es_jobs_empty_title = /** @type {(inputs: Jobs_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay empleos en seguimiento`)
};

const it_jobs_empty_title = /** @type {(inputs: Jobs_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun lavoro monitorato ancora`)
};

const nl_jobs_empty_title = /** @type {(inputs: Jobs_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen banen bijgehouden`)
};

const pl_jobs_empty_title = /** @type {(inputs: Jobs_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak śledzonych ofert pracy`)
};

const fi_jobs_empty_title = /** @type {(inputs: Jobs_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei seurattuja työpaikkoja`)
};

const da_jobs_empty_title = /** @type {(inputs: Jobs_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen job sporet endnu`)
};

const sv_jobs_empty_title = /** @type {(inputs: Jobs_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga jobb spårade ännu`)
};

/**
* | output |
* | --- |
* | "No jobs tracked yet" |
*
* @param {Jobs_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_empty_title = /** @type {((inputs?: Jobs_Empty_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Empty_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_empty_title(inputs)
	if (locale === "fr") return fr_jobs_empty_title(inputs)
	if (locale === "es") return es_jobs_empty_title(inputs)
	if (locale === "it") return it_jobs_empty_title(inputs)
	if (locale === "nl") return nl_jobs_empty_title(inputs)
	if (locale === "pl") return pl_jobs_empty_title(inputs)
	if (locale === "fi") return fi_jobs_empty_title(inputs)
	if (locale === "da") return da_jobs_empty_title(inputs)
	if (locale === "sv") return sv_jobs_empty_title(inputs)
	return en_jobs_empty_title(inputs)
});